import React from 'react';
import { CheckCircle2 } from 'lucide-react';

// currentStep: 1 | 2 — passos 1..(currentStep-1) aparecem concluídos, currentStep ativo, os demais pendentes.
const AdmissaoStepper = ({ currentStep = 1, labels = ['Documentos concluídos', 'Exame admissional'] }) => {
  return (
    <div className="flex items-center">
      {labels.map((label, idx) => {
        const stepNumber = idx + 1;
        const state = stepNumber < currentStep ? 'done' : stepNumber === currentStep ? 'active' : 'pending';
        const isLast = idx === labels.length - 1;
        return (
          <React.Fragment key={label}>
            <div className="flex items-center gap-2">
              {state === 'done' ? (
                <CheckCircle2 className="h-7 w-7 text-emerald-500 shrink-0" />
              ) : (
                <div
                  className={`h-7 w-7 rounded-full flex items-center justify-center text-sm font-semibold shrink-0 ${
                    state === 'active' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-400 border border-gray-300'
                  }`}
                >
                  {stepNumber}
                </div>
              )}
              <span className={`text-sm ${state === 'pending' ? 'text-gray-400' : 'text-gray-900 font-medium'}`}>
                {label}
              </span>
            </div>
            {!isLast && (
              <div className={`h-0.5 w-12 sm:w-20 mx-3 ${stepNumber < currentStep ? 'bg-emerald-400' : 'bg-gray-200'}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default AdmissaoStepper;
